import React, { useCallback, useState } from 'react';
import { FeedbackDashboardAppliedFiltersProps } from '../FeedbackDashboardAppliedFilters';
import LoadAndSaveDialog from './LoadAndSaveDialog';
import { ApplyFilters } from './ShowFilter';

interface LoadFiltersProps extends FeedbackDashboardAppliedFiltersProps {
  anyFiltersApplied: boolean;
  handleApplyAllFilters: (filters: ApplyFilters) => unknown;
}

const LoadAndSaveFilters: React.FC<LoadFiltersProps> = ({
  donorNames,
  relationships,
  portfolioNames,
  cycles,
  status,
  trueImpactStaff,
  dueDates,
  years,
  sortBy,
  anyFiltersApplied,
  handleApplyAllFilters
}) => {
  const [open, setOpen] = useState<boolean>(false);
  const [mode, setMode] = useState<'save' | 'load'>('load');
  const handleOpen = useCallback(() => setOpen(true), [setOpen]);
  const handleClose = useCallback(() => {
    setMode('load');
    setOpen(false);
  }, [setMode, setOpen]);
  const handleSaveClicked = useCallback(() => {
    setMode('save');
    setOpen(true);
  }, [setMode, setOpen]);

  return (
    <>
      <div className="saved_filters__wrapper">
        <button className="button secondary on-dark" onClick={handleOpen}>
          Load Saved Filter &amp; Sort
        </button>
        <button
          className="button on-dark save-button"
          onClick={handleSaveClicked}
          disabled={!anyFiltersApplied}
        >
          Save Filter &amp; Sort
        </button>
      </div>
      <LoadAndSaveDialog
        mode={mode}
        setMode={setMode}
        open={open}
        handleApplyAllFilters={handleApplyAllFilters}
        handleClose={handleClose}
        donorNames={donorNames}
        relationships={relationships}
        portfolioNames={portfolioNames}
        cycles={cycles}
        status={status}
        trueImpactStaff={trueImpactStaff}
        dueDates={dueDates}
        years={years}
        sortBy={sortBy}
      />
    </>
  );
};

export default LoadAndSaveFilters;
